import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Washington = () => {
  return (
    <StatePropertyTaxPage
      stateName="Washington"
      processDescription="Property owners may appeal their assessment by filing with the county board of equalization within 60 days of the value change notice mailing date. Appeals should include evidence supporting the property owner's claimed true and fair value."
      noticeOfValueMailed="April"
      noticeOfValueMailedDateExplanation="Value change notices are typically mailed in April following annual revaluations."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Washington assesses property as of January 1 each year. This assessment date captures the property's true and fair value at the beginning of each calendar year for consistent statewide valuations."
      deadlineExplanation="Property owners have 60 days from the value change notice mailing date to file appeals with the county board of equalization. This typically results in a June deadline."
    />
  );
};

export default Washington;